<template>
    <div>
        <!-- 没有数据 -->
        <div class="ins_blank_imgs" v-if="welcomeData.length==0">
            <div :class="'ins_blank_img ins_blank_img'+(i+1)" v-for="i of 7"></div>
        </div>
        <!-- 有数据 -->
        <div class="ins_blank_imgs" v-if="welcomeData.length==7">
            <div :class="'ins_blank_img ins_blank_img'+(index+1)" v-for="(item,index) of welcomeData">
                <img draggable="false" class="ins_blank_img_base64" :src="item.base64" />
                <img draggable="false" class="ins_blank_img_icon" v-if="item.type==1" src="../../assets/images/imageSaver/typeVideo.svg" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "imageSaverWelcome",
    props: ['welcomeData'],
};
</script>

<style scoped>
/* 空白页所有图片外框 */
.ins_blank_imgs {
    width: 1000px;
    height: 391px;
    position: relative;
}

/* 空白页每个图片 */
.ins_blank_img {
    background-color: rgba(0, 0, 0, 0.03);
    position: absolute;
    z-index: 1;
    width: 188px;
    height: 188px;
    border-radius: 4px;
    overflow: hidden;
}

/* 随机欢迎图片 */
.ins_blank_img_base64 {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

/* 视频图标 */
.ins_blank_img_icon {
    position: absolute;
    z-index: 2;
    right: 20px;
    top: 20px;
}

/* 1,1 */
.ins_blank_img1 {
    left: 0;
    top: 0;
}

/* 1,2 */
.ins_blank_img2 {
    left: 203px;
    top: 0;
}

/* 2,1 */
.ins_blank_img3 {
    left: 0;
    top: 203px;
}

/* 2,2 */
.ins_blank_img4 {
    left: 203px;
    top: 203px;
}

/* 最大图片 */
.ins_blank_img5 {
    left: 406px;
    top: 0;
    width: 391px;
    height: 391px;
    border-radius: 8px;
}

/* 第1排最后一个 */
.ins_blank_img6 {
    right: 0;
    top: 0;
}

/* 第2排最后一个 */
.ins_blank_img7 {
    right: 0;
    top: 203px;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/image_saver_welcome.vue